import { VInternalAspectRemote } from "../api/internal-aspect";
import { VApartmentInternalAspect, VHouseInternalAspect, VOfficeInternalAspect, VRetailBuildingInternalAspect, VRetailShopInternalAspect, VWarehouseInternalAspect } from "../common/internal-aspect";

export function mapApartmentInternalAspectRemoteToDomain(remote: VInternalAspectRemote): VApartmentInternalAspect {
  return {
    windows: remote.windows_name,
    windowsComment: remote.windows_comment,
    ceiling: remote.ceiling_name,
    ceilingComment: remote.ceiling_comment,
    wallsAndPartition: remote.walls_and_partition_name,
    wallsAndPartitionComment: remote.walls_and_partition_comment,
    floors: remote.floor_type_name,
    floorsComment: remote.floor_type_comment,
    bathroomFitting: remote.bathroom_fitting_name,
    bathroomFittingComment: remote.bathroom_fitting_comment,
    others: null,
    // TODO:
    builtInFittings: remote.builtin_fitting_names
  }
}

export function mapVHouseInternalAspectRemoteToDomain(remote: VInternalAspectRemote): VHouseInternalAspect {
  return {
    ceiling: remote.ceiling_name,
    ceilingComment: remote.ceiling_comment,
    wallsAndPartition: remote.walls_and_partition_name,
    wallsAndPartitionComment: remote.walls_and_partition_comment,
    floors: remote.floor_type_name,
    floorsComment: remote.floor_type_name,
    bathroomFitting: remote.bathroom_fitting_name,
    bathroomFittingComment: remote.bathroom_fitting_comment,
    roofStructure: remote.roof_structure_name,
    roofStructureComment: remote.roof_structure_comment,
    fireplacesAndChimney: remote.fireplaces_chimney_breast_name,
    fireplacesAndChimneyComment: remote.fireplaces_chimney_breast_comment,
    woodwork: remote.woodwork,
    woodworkComment: remote.woodwork_comment,
    builtInFittings: remote.builtin_fitting_names,
    others: remote.has_other ? remote.other_aspects : null
  }
}

export function mapVOfficeInternalAspectRemoteToDomain(remote: VInternalAspectRemote): VOfficeInternalAspect {
  return {
    windows: remote.windows_name,
    windowsComment: remote.windows_comment,
    ceiling: remote.ceiling_name,
    ceilingComment: remote.ceiling_comment,
    wallsAndPartition: remote.walls_and_partition_name,
    wallsAndPartitionComment: remote.walls_and_partition_comment,
    floors: remote.floor_type_name,
    floorsComment: remote.floor_type_comment,
    builtInFittings: remote.builtin_fitting_names,
    others: remote.has_other ? remote.other_aspects : null
  }
}

export function mapVRetailBuildingInternalAspectRemoteToDomain(remote: VInternalAspectRemote): VRetailBuildingInternalAspect {
  return {
    ceiling: remote.ceiling_name,
    ceilingComment: remote.ceiling_comment,
    wallsAndPartition: remote.walls_and_partition_name,
    wallsAndPartitionComment: remote.walls_and_partition_comment,
    floors: remote.floor_type_name,
    floorsComment: remote.floor_type_name,
    roofStructure: remote.roof_structure_name,
    roofStructureComment: remote.roof_structure_comment,
    builtInFittings: remote.builtin_fitting_names,
    height: remote.height,
    heightComment: remote.height_comment,
    cubicContent: remote.cubic_content,
    cubicContentComment: remote.cubic_content_comment,
    shopFrontType: remote.shop_front_type_name,
    shopFrontTypeComment: remote.shop_front_type_comment,
    others: remote.has_other ? remote.other_aspects : null
  }
}

export function mapVRetailShopInternalAspectRemoteToDomain(remote: VInternalAspectRemote): VRetailShopInternalAspect {
  return {
    ceiling: remote.ceiling_name,
    ceilingComment: remote.ceiling_comment,
    wallsAndPartition: remote.walls_and_partition_name,
    wallsAndPartitionComment: remote.walls_and_partition_comment,
    floors: remote.floor_type_name,
    floorsComment: remote.floor_type_comment,
    shopFrontType: remote.shop_front_type_name,
    shopFrontTypeComment: remote.shop_front_type_comment,
    builtInFittings: remote.builtin_fitting_names,
    others: remote.has_other ? remote.other_aspects : null
  }
}

export function mapVWarehouseInternalAspectRemoteToDomain(remote: VInternalAspectRemote): VWarehouseInternalAspect {
  return {
    ceiling: remote.ceiling_name,
    ceilingComment: remote.ceiling_comment,
    wallsAndPartition: remote.walls_and_partition_name,
    wallsAndPartitionComment: remote.walls_and_partition_comment,
    floors: remote.floor_type_name,
    floorsComment: remote.floor_type_name,
    roofStructure: remote.roof_structure_name,
    roofStructureComment: remote.roof_structure_comment,
    builtInFittings: remote.builtin_fitting_names,
    others: remote.has_other ? remote.other_aspects : null,
    height: remote.height,
    heightComment: remote.height_comment,
    cubicContent: remote.cubic_content,
    cubicContentComment: remote.cubic_content_comment,
    storageType: remote.storage_type_name,
    storageTypeComment: remote.storage_type_comment,
    automations: remote.has_automation ? remote.automations.map(auto => Number(auto)) : []
  }
}